import { render } from "./ActiveOrders.vue?vue&type=template&id=35f9d658&scoped=true"
import script from "./ActiveOrders.vue?vue&type=script&lang=js"
export * from "./ActiveOrders.vue?vue&type=script&lang=js"

import "./ActiveOrders.vue?vue&type=style&index=0&id=35f9d658&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f9d658"]])

export default __exports__